/**
 * Card component overrides.
 * Glassmorphism cards with subtle borders and blur.
 */

import type { Theme } from '@mui/material/styles';
import type { Skin } from '../../@core/types';

const card = (skin: Skin): Theme['components'] => {
  return {
    MuiCard: {
      defaultProps: {
        ...(skin === 'bordered' && { variant: 'outlined' }),
      },
      styleOverrides: {
        root: ({ ownerState }) => ({
          borderRadius: 'var(--mui-shape-customBorderRadius-lg)',
          border: '1px solid var(--glass-border)',
          backgroundImage: 'var(--gradient-surface)',
          transition: 'border-color 200ms ease, box-shadow 200ms ease',
          ...(ownerState.variant !== 'outlined' && {
            boxShadow: 'var(--mui-customShadows-sm)',
          }),
          '&:hover': {
            borderColor: 'rgba(255, 255, 255, 0.1)',
          },
        }),
      },
    },
    MuiCardHeader: {
      styleOverrides: {
        root: ({ theme }) => ({
          padding: theme.spacing(5, 6),
          '& + .MuiCardContent-root, & + .MuiCardActions-root': {
            paddingBlockStart: 0,
          },
        }),
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: ({ theme }) => ({
          padding: theme.spacing(5, 6),
          '&:last-child': {
            paddingBlockEnd: theme.spacing(5),
          },
        }),
      },
    },
    MuiCardActions: {
      styleOverrides: {
        root: ({ theme }) => ({
          padding: theme.spacing(4, 6),
          '& .MuiButtonBase-root:not(:first-of-type)': {
            marginInlineStart: theme.spacing(4),
          },
        }),
      },
    },
  };
};

export default card;
